import React from 'react';
import ProductCard from '../Cards/ProductCard';
import ProductScroller from './ProductScroller';
import { IProduct } from '../../Api/Models/Products';

interface IFeaturedProductDisplayProps {
    products: IProduct[];
    isDark?: boolean;
    showFeaturedFlag?: boolean;
    // When true, render the products as a horizontal side-scroller instead of the wrap grid
    // (per-section IStorefrontSection.scrollProducts). Undefined/false = grid as before.
    scroll?: boolean;
    // Scroller chrome styling (homePageConfig.scrollButton / scrollbar), only used when scroll is on.
    scrollButtonStyle?: React.CSSProperties;
    scrollbarStyle?: React.CSSProperties;
    // Optional home-page card presentation overrides (homePageConfig). Passed straight
    // through to ProductCard; undefined leaves the card exactly as it renders today.
    cardStyle?: React.CSSProperties;
    // Forwarded to ProductCard, which applies it inline on hover — see its cardHoverStyle prop.
    cardHoverStyle?: React.CSSProperties;
    nameStyle?: React.CSSProperties;
    priceStyle?: React.CSSProperties;
    imageStyle?: React.CSSProperties;
    // Floating add-to-cart button style (homePageConfig.addToCartButton) → ProductCard.
    addToCartStyle?: React.CSSProperties;
    // When provided (the "Recommended For You" row), each card shows a dismiss (✕) control.
    onDismiss?: (productId: string) => void;
}

const FeaturedProductDisplay: React.FC<IFeaturedProductDisplayProps> = (props) => {
    if (props.scroll) {
        return (
            <div style={{marginBottom: '1em', width: '100%'}}>
                <ProductScroller
                    products={props.products}
                    isDark={props.isDark}
                    showFeaturedFlag={props.showFeaturedFlag}
                    scrollButtonStyle={props.scrollButtonStyle}
                    scrollbarStyle={props.scrollbarStyle}
                    cardStyle={props.cardStyle}
                    cardHoverStyle={props.cardHoverStyle}
                    nameStyle={props.nameStyle}
                    priceStyle={props.priceStyle}
                    imageStyle={props.imageStyle}
                    addToCartStyle={props.addToCartStyle}
                    onDismiss={props.onDismiss}
                    source="section"
                />
            </div>
        );
    }
    return (
        <div style={{marginBottom: '1em', alignItems: 'center'}}>
            <div className='card-container'>
                {props.products.map((product) => (
                    <ProductCard
                        showAddToCart={true}
                        key={product.id + product.name}
                        product={product}
                        isDark={props.isDark}
                        showFeaturedFlag={props.showFeaturedFlag}
                        cardStyle={props.cardStyle}
                        cardHoverStyle={props.cardHoverStyle}
                        nameStyle={props.nameStyle}
                        priceStyle={props.priceStyle}
                        imageStyle={props.imageStyle}
                        addToCartStyle={props.addToCartStyle}
                        onDismiss={props.onDismiss}
                        source="section"
                        />
                ))}
            </div>
        </div>
    );
}

export default FeaturedProductDisplay;